import {
  Box, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import useIntegrations from '@hooks/useIntegrations'

import Integration from './Integration'

type IntegrationsProps = {
  userId: number,
}

const Integrations = (props: IntegrationsProps) => {
  const { userId } = props

  const integrationsPayload = useIntegrations({ filters: { integrable_id: userId, integrable_type: 'User' } })
  const {
    filteredIntegrations,
    hasFilteredIntegrations,
    loading,
  } = integrationsPayload

  return (
    <DashboardModule title="Integrations" boxProps={{ marginBottom: 'large' }}>
      <Box flexDirection="column">
        <LoadingModule loading={loading} times={3} />

        {!loading && !hasFilteredIntegrations && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Integration Assigned
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              This user has no integrations assigned to them.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        { hasFilteredIntegrations && filteredIntegrations.map(integration => (
          <Integration key={integration.id} integration={integration} />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default Integrations
